
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";
import { API_TCaseSteps, API_TCaseStep } from "@/models/case_steps";
import { COMPLETE_SERVICE_STATUS, CANDIDATE_ASSESSMENT_SERVICE_TYPE } from "@/constants/services";

import Flag from "@/assets/images/nb.svg";

const ROLE_TYPES = {
  candidate: "person",
  company: "business",
  company_and_candidate: "business",
  employer_and_candidate: "person",
  employer: "person",
  expert: "school",
  home_office: "flag",
  "": null,
};

const ROLE_TYPES_CUSTOM = {
  nation_better: Flag,
  "": null,
};

const ACTION_BY_TYPES = {
  candidate: "Candidate",
  company: "Company",
  company_and_candidate: "Company and candidate",
  expert: "Expert",
  home_office: "Home Office",
  nation_better: "Nation.better",
  "": null,
};

const COLOUR_TYPES = {
  candidate: "person",
  company: "business",
  company_and_candidate: "purple",
  employer_and_candidate: "person",
  employer: "person_employer",
  expert: "school",
  home_office: "flag",
  nation_better: "flag",
  "": null,
};

@Component
export default class CaseCompletion extends Vue {
  @Prop({ type: Boolean, default: false }) readonly needsUpdate!: boolean;

  steps: API_TCaseStep[] = [] as API_TCaseStep[];

  actionByItems: string[] = [];

  currentStepIndex = 0;

  roleTypes = ROLE_TYPES;

  roleTypesCustom = ROLE_TYPES_CUSTOM;

  actionByTypes = ACTION_BY_TYPES;

  colourTypes = COLOUR_TYPES;

  loading = true;

  @Watch("needsUpdate")
  update(val: boolean) {
    if (!val) return;

    this.fetchSteps();
  }

  async mounted() {
    await this.fetchSteps();
  }

  get caseId(): number {
    return Number(this.$route.params.id || 0);
  }

  get isCaseCompleted() {
    return SMCases.caseStatus === COMPLETE_SERVICE_STATUS;
  }

  get isAssessmentServiceType() {
    return SMCases.caseType === CANDIDATE_ASSESSMENT_SERVICE_TYPE;
  }

  async fetchSteps() {
    try {
      this.loading = true;

      const caseDashboardId = SMCases.tabId;

      const { data } = await this.axios.get<API_TCaseSteps>(
        API_ROUTES.CASE_STEPS(this.caseId, caseDashboardId)
      );

      if (!data) return;

      this.steps = data.steps.sort((a: API_TCaseStep, b: API_TCaseStep) => a.index - b.index);

      const lastFetchedStep = this.steps[this.steps.length - 1];

      this.currentStepIndex = data.current_step.index;

      SMCases.setLastStep(this.currentStepIndex === lastFetchedStep.index);

      this.actionByItems = this.steps
        .map((step) => step.belongs_to_role)
        .filter((value, index, step) => step.indexOf(value) === index);

      this.$emit("updated");
    } finally {
      this.loading = false;
    }
  }

  getBelongsToLabel(value) {
    if (!this.isAssessmentServiceType) return "";

    return this.$root.$tc(`belongsToRole.${value}`) || "";
  }
}
